import { render } from "./ProformaDetalle.vue?vue&type=template&id=2ea47044&scoped=true"
import script from "./ProformaDetalle.vue?vue&type=script&lang=js"
export * from "./ProformaDetalle.vue?vue&type=script&lang=js"

import "./ProformaDetalle.vue?vue&type=style&index=0&id=2ea47044&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ea47044"]])

export default __exports__